import { QueryConfig, useQuery } from 'react-query';
import { QUERY_STALE_TIME } from 'config';
import Yup from 'config/yup-locale';
import EntitiesAPI from './api';

type EntitiesParams = {
  entity_id: string;
  document_number: string;
};

export const validationSchema = Yup.object().shape<EntitiesParams>({
  entity_id: Yup.string().required(),
  document_number: Yup.string().min(5).required(),
});

export function useCheckDocumentNumber(
  entitiesParams: EntitiesParams,
  options: QueryConfig<{
    documentNumber: string;
    name: string;
    surname: string;
    creditLimit: string;
    salesPlace: string;
    status: string;
    description: string;
  }>
) {
  return useQuery(
    ['check_document_number', entitiesParams],
    (key, params: EntitiesParams) =>
      EntitiesAPI.checkDocumentNumber({ params }),
    {
      staleTime: QUERY_STALE_TIME,
      enabled: validationSchema.isValidSync(entitiesParams),
      cacheTime: 0,
      ...options,
    }
  );
}
